module.exports = __webpack_public_path__ + "static/media/hair (24).ec5b7cfc.jpg";